module.exports = __webpack_public_path__ + "static/media/Corporate.1d75dcf4.jpg";